export default "__VITE_ASSET__Ce9I81Xk__"